const ProfileBanners = {
  computed: {
    ...Vuex.mapState(['user', 'profile']),
  },
  created: function () {
    this.$dmtk.profile.get().then((data) => {
      this.$store.commit('set', data);
    });
  },
  methods: {
    maybe(n) {
      return Math.floor(Math.random() * n) === 0;
    },
  },
  template: `
      <div class="uk-margin-top" v-if="!$route.path.includes('/mensajes')">
        
        <div
            id="profile-banner-202309"
            class="banner-panel"
            @click="$router.push('/inscripciones#recomendados')"
            v-if="user.jobs ===  0 && $route.path !== '/inscripciones'"
        >
          <div class="icon">
            <img src="/assets/img/icons/line/notificaciones.svg" alt="Notificación" />
          </div>
          <div class="text">
            Nuevas ofertas que se ajustan a tu perfil.
            <strong>Ver las ofertas</strong>.
          </div>
        </div>
        
        <div
            id="companies-banner-202309"
            class="banner-panel"
            @click="$router.push('/empleo/nuevo')"
            v-else-if="user.jobs > 0 && $route.path !== '/empleo/nuevo'"
        >
          <div class="icon">
            <img src="/assets/img/icons/line/crear-oferta.svg" alt="Notificación" />
          </div>
          <div class="text">
            Te ayudamos a contratar los profesionales que necesitas para llevar a cabo tus proyectos o servicios.
            <br/><strong>¡Publica tus ofertas!</strong>
          </div>
        </div>
        
        <div
            id="users-banner-202309"
            class="banner-panel"
            @click="$router.push('/empleo/nuevo')"
            v-else-if="!profile.type && $route.path !== '/empleo/nuevo'"
        >
          <div class="icon">
            <img src="/assets/img/icons/line/crear-oferta.svg" alt="Notificación" />
          </div>
          <div class="text">
            Los anuncios de trabajo o solicitudes de presupuesto te ayudan a contactar con los usuarios que ofrecen los servicios que necesitas.
            <strong>¡Empieza ahora!</strong>
          </div>
        </div>
                
      </div>
  `,
};
